module.exports = __webpack_public_path__ + "static/media/rising-red.2fb25fee.svg";